import React, { useEffect } from 'react';
import firebase from './../firebase';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import ErrorLayout from '../layouts/ErrorLayout';
import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';

import FormValidation from 'components/doc-components/FormValidation';
import WizardForms from 'components/doc-components/WizardForms';
import Logout from 'components/authentication/card/Logout';
import Settings from 'components/pages/user/settings/Settings';
import Users from 'components/pages/users/Users';
import Newuser from 'components/pages/users/Newuser';
import EditUser from 'components/pages/users/Edituser';

import MainLayout from '../layouts/MainLayout';
import Dashboard from 'components/dashboards/default';
import AuthSimpleLayout from '../layouts/AuthSimpleLayout';
import SimpleLogout from 'components/authentication/simple/Logout';
import SimpleLogin from 'components/authentication/simple/Login';
import SimpleForgetPassword from 'components/authentication/simple/ForgetPassword';
import SimplePasswordReset from 'components/authentication/simple/PasswordReset';
import SimpleConfirmMail from 'components/authentication/simple/ConfirmMail';
import SimpleLockScreen from 'components/authentication/simple/LockScreen';
import Crm from 'components/pages/crm/Crm';
import Newucrm from 'components/pages/crm/New';
import CrmEdit from 'components/pages/crm/Edit';
import Bookings from 'components/pages/booking/Booking';
import NewBooking from 'components/pages/booking/New';
import EditBooking from 'components/pages/booking/Edit';
import Villas from 'components/pages/villas/Villa';
import EditVilla from 'components/pages/villas/Edit';
import NewVilla from 'components/pages/villas/New';
import Equipements from 'components/pages/equipements/Equipements';
import Newequipement from 'components/pages/equipements/New';
import FontAwesome from 'components/doc-components/FontAwesome';
import EditEquipement from 'components/pages/equipements/Edit';
import Services from 'components/pages/services/Services';
import Newservice from 'components/pages/services/New';
import EditService from 'components/pages/services/Edit';
import Mailings from 'components/pages/mailings/Mailings';
import NewMailings from 'components/pages/mailings/New';
import EditMailing from 'components/pages/mailings/Edit';
import Demands from 'components/pages/demands/Demands';
import NewDemand from 'components/pages/demands/New';
import EditDemand from 'components/pages/demands/Edit';
import GContractPDF from 'components/pages/demands/Contract';
import Contract from 'components/authentication/simple/contract';
import ContratsList from 'components/pages/contrats/Contrats';
import ViewVilla from 'components/pages/villas/View';
import EtatsdeslieuxList from 'components/pages/etatsdeslieux/Etatsdeslieux';
import EditEtatdeslieux from 'components/pages/etatsdeslieux/Edit';
import StateLieu from 'components/pages/etatsdeslieux/Pdf';
import Search from 'components/pages/search/search';
import NewEmail from 'components/pages/mailings/NewEmail';
import EmailList from 'components/pages/mailings/List';
import Rapports from 'components/pages/rapports/Rapport';
import Comptabilite from 'components/pages/rapports/Comptabilite';
import EditComptabilite from 'components/pages/rapports/Edit';
import Entreesortie from 'components/pages/rapports/Entreesortie';
import OutilRapport from 'components/pages/rapports/Outils';
import WhiteSimpleLayout from 'layouts/WhiteCardLayout';
import FicheMaison from 'components/pages/villas/FicheMaison';
import FicheContact from 'components/pages/villas/FicheContact';
import Calendar from 'components/pages/booking/Calendar';
import ConnectHandler from 'components/pages/Connect';
import Menage from 'components/pages/Menage';
import AuthLargeLayout from 'layouts/AuthLargeLayout';
import SyncEvent from 'components/pages/booking/Sync';
import UsersMenage from 'components/pages/menages/Menages';
import NewuserMenage from 'components/pages/menages/New';
import EditUserMenage from 'components/pages/menages/Edit';
import MenageUser from 'components/pages/MenageUser';
import SyncEventId from 'components/pages/booking/SyncId';
import BodyBlackLayout from 'layouts/BodyBlackLayout';
import MultiStepForm from 'components/pages/questions/MultiStepForm';
import VisualisationReponses from 'components/pages/questions/VisualisationReponses';
import { questionsBefore , questionsSatisfaction} from 'config';
import ViewEmail from 'components/pages/emailViewer';
import PaymentTracking from 'components/pages/payments';


const FalconRoutes = () => {


  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // navigate('/');   
      } else {
      }
    })
  })
  

  return (
    <Routes> 
      <Route element={<BodyBlackLayout />}> 
      
      <Route path="/view-email/:emailId" element={<ViewEmail/>} />
      <Route path="/questions/:reservationId" element={<MultiStepForm questions={questionsBefore} />} />
        <Route path="/thanks/:reservationId" element={<MultiStepForm  questions={questionsSatisfaction} review={true} />} />
      </Route>
      <Route element={<AuthLargeLayout />}>
        <Route path="/menage" element={<Menage />} />
        <Route path="/menage/u/:id" element={<MenageUser />} />
        <Route path="/menage/sync" element={<SyncEvent />} />
        <Route path="/menage/sync/:id" element={<SyncEventId />} />
      </Route>
      <Route element={<AuthSimpleLayout />}>
        <Route path="/connect" element={<ConnectHandler />} />
        <Route path="/login" element={<SimpleLogin />} />
        <Route path="authentication/simple/logout" element={<SimpleLogout />} />
        <Route
          path="authentication/simple/forgot-password"
          element={<SimpleForgetPassword />}
        />
        <Route
          path="authentication/simple/reset-password"
          element={<SimplePasswordReset />}
        />
        <Route
          path="authentication/simple/confirm-mail"
          element={<SimpleConfirmMail />}
        />
        <Route
          path="authentication/simple/lock-screen"
          element={<SimpleLockScreen />}
        />
      </Route>

      <Route element={<WhiteSimpleLayout />}>

        <Route path="contract/:id" element={<Contract />} />
        <Route path="v/:id" element={<ViewVilla logom={true} />} />
        <Route path="vl/:id" element={<ViewVilla logom={false} />} />
        <Route path="v/:id/:pdf" element={<ViewVilla logom={true} />} />
        <Route path="vl/:id/:pdf" element={<ViewVilla logom={false} />} />
        <Route path="etatsdeslieux/pdf/:id" element={<StateLieu />} />

      </Route>

      <Route path="authentication/card/logout" element={<Logout />} />
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
        <Route path="errors/500" element={<Error500 />} />
      </Route>
      <Route element={<MainLayout />}>
        {/*Dashboard*/}
        <Route path="/" element={<Dashboard />} />
        <Route path="/payments" element={<PaymentTracking />} />
        <Route path="/visualisation-reponses/:id" element={<VisualisationReponses />} />
        <Route path="usersmenage" element={<UsersMenage />} />
        <Route path="usersmenage/new" element={<NewuserMenage />} />
        <Route path="usersmenage/edit/:id" element={<EditUserMenage />} />

        <Route path="user/settings" element={<Settings />} />
        <Route path="users" element={<Users />} />
        <Route path="user/edit/:id" element={<EditUser />} />

        <Route path="forms/validation" element={<FormValidation />} />
        <Route path="newuser" element={<Newuser />} />

        <Route path="crm" element={<Crm />} />
        <Route path="newcrm" element={<Newucrm />} />
        <Route path="crm/edit/:id" element={<CrmEdit />} />


        <Route path="bookings" element={<Bookings />} />
        <Route path="newbooking" element={<NewBooking />} />
        <Route path="booking/edit/:id" element={<EditBooking />} />
        <Route path="calendar" element={<Calendar />} />


        <Route path="villas" element={<Villas />} />
        <Route path="villa/edit/:id" element={<EditVilla />} />
        <Route path="villa/edit/:id/fichemaison" element={<FicheMaison />} />
        <Route path="villa/edit/:id/fichecontact" element={<FicheContact />} />
        <Route path="newvilla" element={<NewVilla />} />



        <Route path="equiments" element={<Equipements />} />
        <Route path="equiment/new" element={<Newequipement />} />
        <Route path="equiment/edit/:id" element={<EditEquipement />} />


        <Route path="services" element={<Services />} />
        <Route path="service/new" element={<Newservice />} />
        <Route path="service/edit/:id" element={<EditService />} />


        <Route path="mailings" element={<Mailings />} />
        <Route path="mailing/new" element={<NewMailings />} />
        <Route path="mailing/edit/:id" element={<EditMailing />} />

        <Route path="demands" element={<Demands />} />
        <Route path="demand/new" element={<NewDemand />} />
        <Route path="demand/edit/:id" element={<EditDemand />} />
        <Route path="demand/pdf/:id" element={<GContractPDF />} />


        <Route path="contracts" element={<ContratsList />} />


        <Route path="etatsdeslieux" element={<EtatsdeslieuxList />} />
        <Route path="etatsdeslieux/edit/:id" element={<EditEtatdeslieux />} />
        <Route path="search" element={<Search />} />


        <Route path="/email/new" element={<NewEmail />} />
        <Route path="/email/list" element={<EmailList />} />
        <Route path="/stats" element={<Rapports />} />
        <Route path="/comptabilite" element={<Comptabilite />} />
        <Route path="/comptabilite/:id" element={<EditComptabilite />} />
        <Route path="/entreesortie" element={<Entreesortie />} />
        <Route path="/outilrapport" element={<OutilRapport />} />
      </Route>


      {/* <Route  path="/" element={<button onClick={() => {
        firebase.auth().signOut().then(()=>{
          
        toast.success(`Déconnexion`, {
          theme: 'colored'
        });
          navigate('/login');
          console.log("logout")
        })
      }}>quitter</button>} /> */}
      {/* //--- MainLayout end  */}

      {/* <Navigate to="/errors/404" /> */}
      <Route path="*" element={<Navigate to="/errors/404" replace />} />
    </Routes>
  );
};

export default FalconRoutes;
